<template>
    <DialogDefault
      id="dialog-carencias"
      :open.sync="myOpen"
      title="Carências"
      :top="top"
      @close="close"
    >
      <div>
        <table
          v-if="carencias.length > 0"
          style="font: normal normal 600 14px/19px Open Sans; letter-spacing: 0; color: #555555; width: 100%;"
        >
          <tr
            v-for="(carencia, i) in carencias"
            :key="i"
            style="border-bottom: 1px solid #DDDDDD; height: 43px;"
          >
            <td style="border-bottom: 1px solid #DDDDDD;" class="font-td">{{ carencia.tipoServico }}</td>
            <td style="border-bottom: 1px solid #DDDDDD; " class="font-td regular">{{ parseDate(carencia.carencia) }}</td>
          </tr>
        </table>
        <div v-else>
          Nenhuma carência.
        </div>
      </div>
    </DialogDefault>
</template>
<script>

import DialogDefault from '@/components/DialogDefault/DialogDefault'
import moment from 'moment'

export default {
  name: 'DialogoCarencias',
  components: { DialogDefault },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    carencias: {
      type: Array,
      default: () => []
    },
    top: {
      type: String
    }
  },
  data () {
    return {
      myOpen: false
    }
  },
  watch: {
    value (newValue) {
      this.myOpen = newValue
    }
  },
  mounted () {
    this.myOpen = this.value
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    parseDate (value) {
      const rgxData = /^\d{4}-\d{2}-\d{2}$/
      if (rgxData.test(value)) {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }

      return value
    }
  }
}
</script>
<style lang="less">
#dialog-carencias {
  .default-dialog-title-box {
    padding-bottom: 16px;
  }
  .font-td {
    font-family: "Open Sans";
  }
  .regular {
    font-weight: 500;
  }
}
</style>
